module.exports = __webpack_public_path__ + "img/img0.346fa6c6.jpg";